import React from 'react';
import type {WidgetPart, CTAWidgetPayload} from '../types';
import CTAWidget from './cta-widget';
import {ListWidget} from './list-widget';


interface WidgetRendererProps {
  part: WidgetPart;
  onStepClick?: (
    stepId: string,
    event: {name: string; payload: Record<string, unknown>},
  ) => void;
  onResize?: () => void;
}

export function WidgetRenderer({
  part,
  onStepClick,
  onResize,
}: WidgetRendererProps) {
  const {data} = part;

  if (data.widget_type === 'list') {
    return (
      <ListWidget
        payload={data.payload}
        onStepClick={onStepClick}
        onResize={onResize}
      />
    );
  }

  if (data.widget_type === 'cta') {
    return (
      <CTAWidget
        data={data.payload as CTAWidgetPayload}
        onStepClick={onStepClick}
      />
    );
  }

  return null;
}
